import React from "react";
import { ReactComponent as TriangleArrowUp } from "svg/triangle-arrow-up.svg";
import { ReactComponent as TriangleArrowDown } from "svg/triangle-arrow-down.svg";

const LPGainArrows = ({ lpAvg }) => (
  <span className="lp-gain-arrows">
    {lpAvg > 0 && (
      <>
        <TriangleArrowUp className="inline-block lp-arrow" /> <span className="qty">{lpAvg}</span> LP
      </>
    )}
    {lpAvg < 0 && (
      <>
        <TriangleArrowDown className="inline-block lp-arrow loss" /> <span className="qty">{Math.abs(lpAvg)}</span> LP
      </>
    )}
    {lpAvg == 0 && (
      <>
        <span className="qty">0</span> LP
      </>
    )}
  </span>
);
export default LPGainArrows;
